import type { ReactElement } from "react";
import { Navigate, useParams } from "react-router-dom";

import { isUuid } from "@/lib/parseUuidListParam";

export function FinanceReceivablesCreateRedirect(): ReactElement {
  return <Navigate to="/finance/receivables?create=1" replace />;
}

export function FinanceReceivablesEditRedirect(): ReactElement {
  const { id } = useParams<{ id: string }>();
  if (!id || !isUuid(id)) {
    return <Navigate to="/finance/receivables" replace />;
  }
  return <Navigate to={`/finance/receivables?edit=${id}`} replace />;
}
